export type TAchievementId =
  | 'first-win'
  | 'quick-win'
  | 'one-on-one-win'
  | 'login-streak-30'
  | 'login-streak-60';

export interface IAchievementConfig {
  id: TAchievementId;
  name: string;
  description: string;
  enabled: boolean;
  conditions?: {
    thresholdSeconds?: number;
    thresholdByGame?: Record<number, number>;
  };
}

export const ACHIEVEMENTS_REGISTRY: Record<TAchievementId, IAchievementConfig> =
  {
    'first-win': {
      id: 'first-win',
      name: 'First Win',
      description: 'Win your first game',
      enabled: true,
    },
    'quick-win': {
      id: 'quick-win',
      name: 'Quick Win',
      description: 'Win a game within 60 seconds',
      enabled: true,
      conditions: {
        thresholdSeconds: 60,
      },
    },
    'one-on-one-win': {
      id: 'one-on-one-win',
      name: 'One-on-One Winner',
      description: 'Win a 1v1 match',
      enabled: false,
    },
    'login-streak-30': {
      id: 'login-streak-30',
      name: '30 Day Streak',
      description: 'Log in 30 days in a row',
      enabled: true,
    },
    'login-streak-60': {
      id: 'login-streak-60',
      name: '60 Day Streak',
      description: 'Log in 60 days in a row',
      enabled: true,
    },
  };

export function getAchievementConfig(id: TAchievementId): IAchievementConfig {
  const config = ACHIEVEMENTS_REGISTRY[id];
  if (!config) {
    throw new Error(`Achievement config not found: ${id}`);
  }
  return config;
}

export function getEnabledAchievements(): IAchievementConfig[] {
  return Object.values(ACHIEVEMENTS_REGISTRY).filter((a) => a.enabled);
}

export function isAchievementEnabled(id: TAchievementId): boolean {
  return ACHIEVEMENTS_REGISTRY[id]?.enabled ?? false;
}
